// @flow

import styled from 'styled-components';

export const FormRoot = styled.div`
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: dense;

  & > * {
    grid-column: 1/3;
  }
`;
